export * from "./Department";

export * from "./Affiliation";

export * from "./IDepartmentRegistry";

export * from "./IDepartmentRepository";
export * from "./DepartmentGroup";
